<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="任务标题" prop="user">
              <a-input v-model="task.title" placeholder="请输入任务标题">
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="任务类型" prop="password">
              <a-select
                default-value=""
                style="width: 120px"
                @change="handleChange"
                v-model="task.type"
              >
                <a-select-option value="1"> 签到 </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" @click="seach"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <taskManagementHomeContent
          ref="aaa"
          :task="task"
        ></taskManagementHomeContent>
      </div>
    </a-layout-content>
    <!-- <memberManagementContent></memberManagementContent> -->
  </div>
</template>

<script>
import taskManagementHomeContent from "./taskManagementHomeContent.vue";
export default {
  components: {
    taskManagementHomeContent,
  },
  data() {
    return {
      task: {
        title: "",
        type: "",
        limit: 10,
        page: 1,
      },
    };
  },
  methods: {
    seach() {
      this.$refs.aaa.query();
    },
    resetForm() {
      this.$refs.aaa.getTaskListData();
      this.task = {};
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/marketingManagement/taskManagement/taskManagementHome.vue